import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { ActivatedRoute, ParamMap } from '@angular/router'
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { ValidatorUtils } from '../core/_util/validator-util';

@Component({
  selector: 'app-persona-asignada',
  templateUrl: './persona-asignada.component.html',
  styleUrls: ['./persona-asignada.component.scss']
})
export class PersonaAsignadaComponent extends ValidatorUtils implements OnInit {

  @Input() fichaActual: any;

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;

  //lista de registros
  registrosLista: any;
  columnas: any[];
  totalRecords = 0;
  listaServicios: any[];
  listadoPersonas: any[];
  listadoRoles: any[];
  rolSeleccionado: any;
  listaPersonas: any;
  personas: any;
  espanol: any;
  estado: any;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulario = this.formBuilder.group({
      estado: ['', Validators.required],
      personas: ['', Validators.required],
      rolSeleccionado: ['', Validators.required],
    });
    this.estado = [
      { name: 'ACTIVO', code: 'ACT' },
      { name: 'INACTIVO', code: 'INACT' }
    ];
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombre_rol', header: 'Rol' },
      { field: 'nombre', header: 'Persona a Cargo' },
      { field: 'estado', header: 'Estado' },
    ];

    this.totalRecords = 0;
    this.listar();
    this.getlistaRoles();

  }


  nuevo() {
    this.formulario.reset();
    this.mostrarFormulario = true;
    this.registroNuevo = true;
  }

  editar(data) {
    this.registroNuevo = false;
    this.mostrarFormulario = true;
  }

  volver() {
    this.mostrarFormulario = false;
    this.submitted = false;
  }

  guardar() {
    var dat = this.formulario.valid;

    this.formulario.markAllAsTouched();
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar este registro?',
        accept: () => {
          this.submitted = true;
          this.guardarPersonal();
        }
      });
    }
  }

  listar() {
    let data = {
      id_ficha: this.fichaActual

    }
    this.mostrarFormulario = false;
    this.coreService.getWithParams('/obtenerPersonasFicha', data).subscribe(
      (res: any[]) => {
        // console.log(res);
        this.listadoPersonas = res;
        this.totalRecords = this.listadoPersonas.length;

      },
      (err: any) => {
        console.log(err);
      }
    )

  }
  getlistaRoles() {
    this.coreService.get('/listas/obtenerlistaRoles').subscribe(

      (res: any) => {
        this.listadoRoles = res;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  getListaPersonas() {
    let params = {
      id_rol: this.formulario.value.rolSeleccionado.id,
    }
    this.coreService.getWithParams('/obtenerPersonas', params).subscribe(
      (res: any) => {
        this.listaPersonas = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  guardarPersonal() {

    let data = {
      fichaActual: this.fichaActual,
      persona_id: this.formulario.value.personas.id_personas,
      role_id: this.formulario.value.rolSeleccionado.id,
      estado: this.formulario.value.estado.code
    }

    this.coreService.post('/guardar-personal-ficha', data).subscribe(
      (res: any[]) => {
        this.msj.info('Registro Guardado.');
        this.listar();
        this.mostrarFormulario = false;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }



  eliminar(idRegistro) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar el registro con ID:' + idRegistro.id + '?',
      accept: () => {
        this.submitted = true;
        this.eliminarServicio(idRegistro.id);
        this.mostrarFormulario = false;

      }
    });
  }

  eliminarServicio(idRegistro) {
    this.coreService.delete('/eliminar-persona-ficha', idRegistro).subscribe(
      (res: any[]) => {
        this.msj.info('Registro Eliminado.');
        this.listar();
      },
      (err: any) => {
        if (err.error !== undefined && err.error !== null) {
          for (let index = 0; index < err.error.length; index++) {
            this.msj.error(err.error[index]);
          }
        }
      }
    );
  }

}

